import React from 'react';
import { useLocation } from 'react-router-dom';
import ResetPassword from './ResetPassword';

function ResetPasswordFunc() {
  const location = useLocation();

  return <ResetPassword location={location} />;
}

export default ResetPasswordFunc;
